import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutSection from "./sections/AboutSection";
import PourquoiNousChoisir from "./sections/PourquoiNousChoisir";
import Testimonials from "./sections/Testimonials";
import AppelActionPrincipal from "./sections/AppelActionPrincipal";
import PiedDePage from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AboutSection />
      <PourquoiNousChoisir />
      <Testimonials />
      <AppelActionPrincipal />
      <PiedDePage />
    </div>;
}